module.exports = __webpack_public_path__ + "sao-paulo-toquio.c586c673e344c62644e4c7d6f21fa5a8.jpg";